import React, { Component } from "react";
import styles from "./routeTripsContent.module.scss";

class RouteTitle extends Component {
  render() {
    const { route } = this.props;

    return (
      <div className={styles.routeTitleContainer}>
        <div>Маршрут: {route.title} </div>
        {route.controlPoints.length > 0 ? (
          <div>
            {route.controlPoints[0].title} - {route.controlPoints[route.controlPoints.length - 1].title}
          </div>
        ) : null}
      </div>
    );
  }
}

export default React.memo(RouteTitle);
